import styled from 'styled-components'

interface IFileListStyledProps {}

export const FileListStyled = styled.div<IFileListStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
